import { Map, List } from 'immutable';
import createSelector from '../../utils/reselect';
import { APPOINTMENTS_LICENSES, PERSON_APPOINTMENTS, PERSON_CONTACTS, PERSON_LICENSES } from '../app.constants';
import { PersonLicenseSubView, PersonTypeConfiguration, AppointmentLicenseSubView } from '../modules/person/types';

export const getPerson = (state: any) => {
    const { person } = state;
    return person || Map();
};

export const getPersonDetailLoading = createSelector(getPerson, (state) => {
    return state.getIn(['personDetail', 'loading']);
});

export const getPersonDetail = createSelector(getPerson, (state) => {
    return state.getIn(['personDetail', 'data']) || Map();
});

export const getPersonEditForm = createSelector(getPerson, (state) => {
    return state.getIn(['personEditForm', 'data']) || Map();
});

export const getUpdatePersonLoader = createSelector(getPerson, (state) => {
    return state.getIn(['personDetail', 'loading']);
});

export const getPersonLicensesListLoadingStatus = createSelector(getPerson, (state) => {
    return state.getIn(['personLicenses', 'loading']);
});

export const getPersonLicensesList = createSelector(getPerson, (state) => {
    return state.getIn(['personLicenses', 'data']) || List();
});

export const getContactTypes = createSelector(getPerson, (state) => {
    return state.getIn(['contactTypes', 'data']) || List();
});

/**
 * getPersonAccounting will return accounting records for the license
 */
export const getPersonAccounting = createSelector(getPerson, (state) => {
    return state.getIn(['personAccounting', 'data']) || List();
});

export const getPersonAccountingStatus = createSelector(getPerson, (state) => {
    return state.getIn(['personAccounting', 'loading']);
});

export const getPersonAccountingErrorStatus = createSelector(getPerson, (state) => {
    return state.getIn(['personAccounting', 'error']);
});

/*
 * getAppointmentList will return application Appointment list
 */
export const getAppointmentList = createSelector(getPerson, (state) => {
    return state.getIn(['appointmentList', 'data']) || List();
});
/*
 * getAppointmentListLoadingStatus will return get appointment api loader status
 */
export const getAppointmentListLoadingStatus = createSelector(getPerson, (state) => {
    return state.getIn(['appointmentList', 'loading']);
});

export const getAppointmentTypeList = createSelector(getPerson, (state) => {
    return state.getIn(['appointmentTypeList', 'data']) || List();
});
export const getAppointmentTypeListLoadingStatus = createSelector(getPerson, (state) => {
    return state.getIn(['appointmentTypeList', 'loading']);
});

export const getAppointmentInspectionList = createSelector(getPerson, (state) => {
    return state.getIn(['appointmentInspection', 'data']) || List();
});

export const getAppointmentInspectionLoading = createSelector(getPerson, (state) => {
    return state.getIn(['appointmentInspection', 'loading']);
});

export const getLoadMoreAppointmentInspection = createSelector(getPerson, (state) => {
    return state.getIn(['appointmentInspection', 'loadMore']);
});

export const getPersonContactLoader = createSelector(getPerson, (state) => {
    return state.getIn(['personContacts', 'loading']);
});

export const getPersonContacts = createSelector(getPerson, (state) => {
    return state.getIn(['personContacts', 'data']) ?? [];
});

/*
 * getAppointmentList will return application Appointment list
 */
export const getLicenseListAppointment = createSelector(getPerson, (state) => {
    return state.getIn(['applicationListForAppointment', 'data']) || List();
});

export const getAppointmentDetailLoading = createSelector(getPerson, (state) => {
    return state.getIn(['appointmentDetail', 'loading']);
});

export const getAppointmentDetail = createSelector(getPerson, (state) => {
    return state.getIn(['appointmentDetail', 'data']) || Map();
});

export const getAppointmentEditForm = createSelector(getPerson, (state) => {
    return state.getIn(['appointmentEditForm', 'data']) || Map();
});

export const getUpdateAppointmentLoader = createSelector(getPerson, (state) => {
    return state.getIn(['appointmentDetail', 'loading']);
});

export const getAddPersonCommentLoader = createSelector(getPerson, (state) => {
    return state.getIn(['personComment', 'loading']);
});

export const getPersonCommentList = createSelector(getPerson, (state) => {
    return state.getIn(['personComment', 'data']) || List;
});

export const getPersonCommentListLoader = createSelector(getPerson, (state) => {
    return state.getIn(['personComment', 'loading']);
});

export const getPersonTypesList = createSelector(getPerson, (state) => {
    return state.getIn(['personTypes', 'data']) || List();
});

export const getPersonTypeForm = createSelector(getPerson, (state) => {
    return state.getIn(['personTypeForm', 'data']) || Map();
});

export const getAppointmentCommentList = createSelector(getPerson, (state) => {
    return state.getIn(['appointmentComment', 'data']) || List();
});

export const getAppointmentCommentLoading = createSelector(getPerson, (state) => {
    return state.getIn(['appointmentComment', 'loading']);
});
/*
 * getAppointmentCommentListLoadingStatus will return AppointmentComment list api loader status
 */
export const getAppointmentCommentListLoadingStatus = createSelector(getPerson, (state) => {
    return state.getIn(['appointmentComment', 'loading']);
});

/*
 * load more boolean to see if there are more record for license on server
 */
export const getLoadMoreLicense = createSelector(getPerson, (state) => {
    return state.getIn(['personLicenses', 'loadMore']);
});

/* load more boolean to see if there are more record for appointments on server
 */
export const getLoadMoreAppointment = createSelector(getPerson, (state) => {
    return state.getIn(['appointmentList', 'loadMore']);
});

/* load more boolean to see if there are more record for person contact on server
 */
export const getLoadMorePersonContacts = createSelector(getPerson, (state) => {
    return state.getIn(['personContacts', 'loadMore']);
});

/*
 * load more boolean to see if there are more record for commentList for appointments on server
 */
export const getLoadMoreAppointmentCommentList = createSelector(getPerson, (state) => {
    return state.getIn(['appointmentComment', 'loadMore']);
});

/* load more boolean to see if there are more record for person contact on server
 */
export const getLoadMorePersonComment = createSelector(getPerson, (state) => {
    return state.getIn(['personComment', 'loadMore']);
});

export const getLoadMorePersonAccounting = createSelector(getPerson, (state) => {
    return state.getIn(['personAccounting', 'loadMore']);
});

/*
 * getPersonFilesList will return person files list
 */
export const getPersonFilesList = createSelector(getPerson, (state) => {
    return state.getIn(['personFiles', 'data']) || List();
});
/*
 * getPersonFileListLoadingStatus will return get files api loader status
 */
export const getPersonFileListLoadingStatus = createSelector(getPerson, (state) => {
    return state.getIn(['personFiles', 'loading']);
});

export const getLoadMorePersonFile = createSelector(getPerson, (state) => {
    return state.getIn(['personFiles', 'loadMore']);
});

export const getAddPersonForm = createSelector(getPerson, (state) => {
    return state.getIn(['addPersonForm', 'data']);
});

export const getAddPersonFormLoadingStatus = createSelector(getPerson, (state) => {
    return state.getIn(['addPersonForm', 'loading']);
});
/*
 * getAppointmentCount will return total appointment count
 */
export const getAppointmentCount = createSelector(getPerson, (state) => {
    return state.getIn(['appointmentList', 'appointmentCount']);
});

/*
 * getPersonLicenseCount will return total person's license count
 */
export const getPersonLicenseCount = createSelector(getPerson, (state) => {
    return state.getIn(['personLicenses', 'licenseCount']);
});

/*
 * getAppointmentInspectionCount will return total inspection count in an appointment
 */
export const getAppointmentInspectionCount = createSelector(getPerson, (state) => {
    return state.getIn(['appointmentInspection', 'inspectionCount']);
});

/*
 * getPersonContactsCount will return total person contact count
 */
export const getPersonContactsCount = createSelector(getPerson, (state) => {
    return state.getIn(['personDetail', 'contactsCount']);
});

export const getAppointmentPersonList = createSelector(getPerson, (state) => {
    return state.getIn(['appointmentPersons', 'data']) || List();
});

export const getPersonLicenseColumnFields = createSelector(getPerson, (state) => {
    const personTypeId = state.getIn(['personDetail', 'data', 'type'])?.id;
    const personSubViews = state.getIn(['personTypes', 'data'])?.find(({ id }: { id: string }) => id === personTypeId)
        ?.views?.edit?.subviews;
    return personSubViews?.length > 0
        ? personSubViews.find((subView: PersonLicenseSubView) => subView.id === PERSON_LICENSES)
        : [];
});

export const getPersonContactColumnFields = createSelector(getPerson, (state) => {
    const subViews = state.getIn(['personTypes', 'data']);
    return subViews && subViews.length
        ? subViews &&
              subViews
                  .find((v: PersonTypeConfiguration) =>
                      v?.views?.edit?.subviews?.find((s: PersonLicenseSubView) => s.id === PERSON_CONTACTS),
                  )
                  ?.views?.edit?.subviews.find((s: PersonLicenseSubView) => s.id === PERSON_CONTACTS)
        : [];
});

export const getHistoryList = createSelector(getPerson, (state) => {
    return state.getIn(['personHistory', 'data']);
});

export const getHistoryListStatus = createSelector(getPerson, (state) => {
    return state.getIn(['personHistory', 'loading']);
});

export const getPersonAppointmentColumnFields = createSelector(getPerson, (state) => {
    const personTypeId = state.getIn(['personDetail', 'data', 'type'])?.id;
    const personSubViews = state.getIn(['personTypes', 'data'])?.find(({ id }: { id: string }) => id === personTypeId)
        ?.views?.edit?.subviews;
    return personSubViews?.length > 0
        ? personSubViews.find((subView: PersonLicenseSubView) => subView.id === PERSON_APPOINTMENTS)
        : [];
});

export const getPersonTabs = createSelector(getPerson, (state) => {
    const subViews = state.getIn(['personType', 'data', 'views', 'edit', 'subviews']);
    return subViews;
});

export const getAppointmentLicenseColumnFields = createSelector(getPerson, (state) => {
    const appointmentTypeId = state.getIn(['appointmentDetail', 'data', 'type'])?.id;
    const appointmentLicenseSubViews = state
        .getIn(['appointmentTypeList', 'data'])
        ?.find(({ id }: { id: string }) => id === appointmentTypeId)?.views?.edit?.subviews;
    return appointmentLicenseSubViews?.length > 0
        ? appointmentLicenseSubViews.find((subView: AppointmentLicenseSubView) => subView?.id === APPOINTMENTS_LICENSES)
        : [];
});
